import { customerList, customerDetail, getRate } from '@/api/accountManage'
// import { subtractDate } from '@/utils'
const state = {
  form: {
    company_name: ''
  },
  pages: {
    page: 1,
    pageSize: 10,
    total: 0
  },
  tableList: [] // 客户列表
}
const getters = {
  form: state => state.form,
  pages: state => state.pages,
  tableList: state => state.tableList
}
const mutations = {
  save: (state, payload) => {
    Object.keys(payload).forEach(e => {
      if (Object.prototype.toString.call(state[e]) === '[object Object]') {
        state[e] = {
          ...state[e],
          ...payload[e]
        }
      } else {
        state[e] = payload[e]
      }
    })
  }
}
const actions = {
  // 客户列表
  partWorkListFn({ commit, state }, params = {}) {
    return new Promise(async(resolve, reject) => {
      const { code, data } = await customerList(params)
      if (code === 200) {
        commit('save', {
          tableList: data.data,
          pages: {
            ...state.pages,
            total: data.total
          }
        })
        resolve()
      }
    })
  },
  // 客户详情
  customerDetail(_, params = {}) {
    return new Promise(async(resolve, reject) => {
      const res = await customerDetail(params)
      if (res.code === 200) {
        res && resolve(res)
      }
    })
  },
  // 查看客户费率
  getRateFn(_, params = {}) {
    return new Promise(async(resolve, reject) => {
      const res = await getRate(params)
      if (res.code === 200) {
        res && resolve(res)
      }
    })
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}

